export const enum ProjectsActionType {
  ADDED_PROJECT = 'ADDED_PROJECT',
  ADDED_LOCAL_MODEL_TO_PROJECT = 'ADDED_LOCAL_MODEL_TO_PROJECT',
  ADDED_FILE_UPLOADS_TO_PROJECT = 'ADDED_FILE_UPLOADS_TO_PROJECT',
  ADDED_VIRTUAL_GRAPHS_TO_PROJECT = 'ADDED_VIRTUAL_GRAPHS_TO_PROJECT',
  ADDED_SUGGESTIONS_TO_PROJECT = 'ADDED_SUGGESTIONS_TO_PROJECT',

  DUPLICATED_LOCAL_PROJECT = 'DUPLICATED_LOCAL_PROJECT',
  EXPORTED_PROJECT = 'EXPORTED_PROJECT',
  LOADED_PROJECT_FROM_CLOUD = 'LOADED_PROJECT_FROM_CLOUD',
  IMPORTED_PROJECT_FROM_FILE = 'IMPORTED_PROJECT_FROM_FILE',
  IMPORTED_INVALID_PROJECT_FROM_FILE = 'IMPORTED_INVALID_PROJECT_FROM_FILE',
  ARCHIVED_PROJECT = 'ARCHIVED_PROJECT',
  MIGRATED_LOCAL_PROJECT_BACKUP_TO_CLOUD = 'MIGRATED_LOCAL_PROJECT_BACKUP_TO_CLOUD',
  MIGRATED_LOCAL_PROJECT_TO_CLOUD = 'MIGRATED_LOCAL_PROJECT_TO_CLOUD',
  MIGRATED_CLOUD_PROJECT_TO_LOCAL = 'MIGRATED_CLOUD_PROJECT_TO_LOCAL',
  DUPLICATED_CLOUD_BACKUP_TO_LOCAL_PROJECT = 'DUPLICATED_CLOUD_BACKUP_TO_LOCAL_PROJECT',
  BACKED_UP_CLOUD_PROJECT_TO_LOCAL_PROJECT = 'BACKED_UP_CLOUD_PROJECT_TO_LOCAL_PROJECT',
  RENAMED_PROJECT = 'RENAMED_PROJECT',
  RESTORED_LOCAL_PROJECT = 'RESTORED_LOCAL_PROJECT',
  RESTORED_CLOUD_PROJECT = 'RESTORED_CLOUD_PROJECT',
  OPENED_MISSING_PROJECT = 'OPENED_MISSING_PROJECT',
  CLEARED_PROJECT_VOICEBOX_EVALUATION = 'CLEARED_PROJECT_VOICEBOX_EVALUATION',
  EVALUATED_PROJECT_COMPETENCY_QUESTIONS = 'EVALUATED_PROJECT_COMPETENCY_QUESTIONS',
  EVALUATED_PROJECT_SUMMARY = 'EVALUATED_PROJECT_SUMMARY',
  OPENED_PROJECT_COMPETENCY_QUESTION = 'OPENED_PROJECT_COMPETENCY_QUESTION',
  UPDATED_PROJECT_CONNECTION_ID = 'UPDATED_PROJECT_CONNECTION_ID',
  UPDATED_PROJECT_FILE_UPLOAD = 'UPDATED_PROJECT_FILE_UPLOAD',
  UPDATED_PROJECT_VIRTUAL_GRAPH = 'UPDATED_PROJECT_VIRTUAL_GRAPH',
  UPDATED_PROJECT_DESCRIPTION = 'UPDATED_PROJECT_DESCRIPTION',
  UPDATED_PROJECT_DATA_NAMESPACE = 'UPDATED_PROJECT_DATA_NAMESPACE',
  UPDATED_PROJECT_DIAGRAM = 'UPDATED_PROJECT_DIAGRAM',
  UPDATED_PROJECT_MODEL = 'UPDATED_PROJECT_MODEL',
  UPDATED_PROJECT_PROPERTY_TYPE = 'UPDATED_PROJECT_PROPERTY_TYPE',
  UPDATED_PROJECT_TARGET_MODEL_ID = 'UPDATED_PROJECT_TARGET_MODEL_ID',
  UPDATED_PROJECT_VIRTUAL_GRAPH_PREVIEW_ERROR = 'UPDATED_PROJECT_VIRTUAL_GRAPH_PREVIEW_ERROR',
  UPDATED_PROJECT_VOICEBOX_CONVERSATION = 'UPDATED_PROJECT_VOICEBOX_CONVERSATION',
  UPDATED_PROJECT_VOICEBOX_SUGGESTIONS_ENDPOINT = 'UPDATED_PROJECT_VOICEBOX_SUGGESTIONS_ENDPOINT',
  UPDATED_PROJECT_DISABLE_VOICEBOX_SUGGESTIONS = 'UPDATED_PROJECT_DISABLE_VOICEBOX_SUGGESTIONS',

  ACCEPTED_PROJECT_DRAFT_DIAGRAM = 'ACCEPTED_PROJECT_DRAFT_DIAGRAM',
  REJECTED_PROJECT_DRAFT_DIAGRAM = 'REJECTED_PROJECT_DRAFT_DIAGRAM',

  ADD_IMPORTED_MODELS_TO_PROJECT_STARTED = 'ADD_IMPORTED_MODELS_TO_PROJECT_STARTED',
  ADD_IMPORTED_MODELS_TO_PROJECT_FINISHED = 'ADD_IMPORTED_MODELS_TO_PROJECT_FINISHED',
  ADD_UPLOADED_MODEL_TO_PROJECT_STARTED = 'ADD_UPLOADED_MODEL_TO_PROJECT_STARTED',
  ADD_UPLOADED_MODEL_TO_PROJECT_FINISHED = 'ADD_UPLOADED_MODEL_TO_PROJECT_FINISHED',

  ADDED_PENDING_MODEL_DATA_TO_PROJECT = 'ADDED_PENDING_MODEL_DATA_TO_PROJECT',

  GENERATE_PROJECT_VOICEBOX_STORED_QUERIES_ATTEMPT = 'GENERATE_PROJECT_VOICEBOX_STORED_QUERIES_ATTEMPT',
  GENERATE_PROJECT_VOICEBOX_STORED_QUERIES_FAILURE = 'GENERATE_PROJECT_VOICEBOX_STORED_QUERIES_FAILURE',
  GENERATE_PROJECT_VOICEBOX_STORED_QUERIES_SUCCESS = 'GENERATE_PROJECT_VOICEBOX_STORED_QUERIES_SUCCESS',

  IMPORTED_MODEL_WITH_UNSUPPORTED_PARTS = 'IMPORTED_MODEL_WITH_UNSUPPORTED_PARTS',

  UPLOADED_MISMATCHED_HEADERS_CSV = 'UPLOADED_MISMATCHED_HEADERS_CSV',
  UPLOADED_PARTIAL_CSV = 'UPLOADED_PARTIAL_CSV',

  PUBLISH_UNIQUE_KEY_SETS_STARTED = 'PUBLISH_UNIQUE_KEY_SETS_STARTED',
  PUBLISH_UNIQUE_KEY_SETS_FINISHED = 'PUBLISH_UNIQUE_KEY_SETS_FINISHED',

  PUBLISH_PERMISSION_DENIED = 'PUBLISH_PERMISSION_DENIED',
  PUBLISH_PROJECT_STARTED = 'PUBLISH_PROJECT_STARTED',
  PUBLISH_PROJECT_FINISHED = 'PUBLISH_PROJECT_FINISHED',

  REQUEST_PROJECT_MODEL_CLASSES_ATTEMPT = 'REQUEST_PROJECT_MODEL_CLASSES_ATTEMPT',
  REQUEST_PROJECT_MODEL_CLASSES_FAILURE = 'REQUEST_PROJECT_MODEL_CLASSES_FAILURE',
  REQUEST_PROJECT_MODEL_CLASSES_SUCCESS = 'REQUEST_PROJECT_MODEL_CLASSES_SUCCESS',

  REQUEST_PROJECT_MODEL_LABELS_AND_DESCRIPTIONS_ATTEMPT = 'REQUEST_PROJECT_MODEL_LABELS_AND_DESCRIPTIONS_ATTEMPT',
  REQUEST_PROJECT_MODEL_LABELS_AND_DESCRIPTIONS_FAILURE = 'REQUEST_PROJECT_MODEL_LABELS_AND_DESCRIPTIONS_FAILURE',
  REQUEST_PROJECT_MODEL_LABELS_AND_DESCRIPTIONS_SUCCESS = 'REQUEST_PROJECT_MODEL_LABELS_AND_DESCRIPTIONS_SUCCESS',

  REQUEST_PROJECT_MODEL_GEO_DATA_ATTEMPT = 'REQUEST_PROJECT_MODEL_GEO_DATA_ATTEMPT',
  REQUEST_PROJECT_MODEL_GEO_DATA_FAILURE = 'REQUEST_PROJECT_MODEL_GEO_DATA_FAILURE',
  REQUEST_PROJECT_MODEL_GEO_DATA_SUCCESS = 'REQUEST_PROJECT_MODEL_GEO_DATA_SUCCESS',

  REQUEST_PROJECT_MODEL_PROPERTIES_ATTEMPT = 'REQUEST_PROJECT_MODEL_PROPERTIES_ATTEMPT',
  REQUEST_PROJECT_MODEL_PROPERTIES_FAILURE = 'REQUEST_PROJECT_MODEL_PROPERTIES_FAILURE',
  REQUEST_PROJECT_MODEL_PROPERTIES_SUCCESS = 'REQUEST_PROJECT_MODEL_PROPERTIES_SUCCESS',

  REQUEST_PROJECT_MODEL_RULES_ATTEMPT = 'REQUEST_PROJECT_MODEL_RULES_ATTEMPT',
  REQUEST_PROJECT_MODEL_RULES_FAILURE = 'REQUEST_PROJECT_MODEL_RULES_FAILURE',
  REQUEST_PROJECT_MODEL_RULES_SUCCESS = 'REQUEST_PROJECT_MODEL_RULES_SUCCESS',

  REQUEST_PROJECT_MODEL_VOICEBOX_INSTRUCTIONS_ATTEMPT = 'REQUEST_PROJECT_MODEL_VOICEBOX_INSTRUCTIONS_ATTEMPT',
  REQUEST_PROJECT_MODEL_VOICEBOX_INSTRUCTIONS_FAILURE = 'REQUEST_PROJECT_MODEL_VOICEBOX_INSTRUCTIONS_FAILURE',
  REQUEST_PROJECT_MODEL_VOICEBOX_INSTRUCTIONS_SUCCESS = 'REQUEST_PROJECT_MODEL_VOICEBOX_INSTRUCTIONS_SUCCESS',

  REFRESH_PROJECT_MODEL_FAILED = 'REFRESH_PROJECT_MODEL_FAILED',
  REFRESH_PROJECT_MODEL_NO_CHANGES = 'REFRESH_PROJECT_MODEL_NO_CHANGES',

  ADDED_PENDING_FILE_UPLOADS = 'ADDED_PENDING_FILE_UPLOADS',
  CLEARED_PENDING_FILE_UPLOADS = 'CLEARED_PENDING_FILE_UPLOADS',

  ADDED_PENDING_VIRTUAL_GRAPHS = 'ADDED_PENDING_VIRTUAL_GRAPHS',
  CLEARED_PENDING_VIRTUAL_GRAPHS = 'CLEARED_PENDING_VIRTUAL_GRAPHS',

  ADDED_PENDING_AUTO_GENERATE_MODEL = 'ADDED_PENDING_AUTO_GENERATE_MODEL',
  CLEARED_PENDING_AUTO_GENERATE_MODEL = 'CLEARED_PENDING_AUTO_GENERATE_MODEL',

  ADDED_PENDING_AUTO_GENERATE_MOCK_DATA = 'ADDED_PENDING_AUTO_GENERATE_MOCK_DATA',
  CLEARED_PENDING_AUTO_GENERATE_MOCK_DATA = 'CLEARED_PENDING_AUTO_GENERATE_MOCK_DATA',

  RECEIVED_COLLABORATION_UPDATE = 'RECEIVED_COLLABORATION_UPDATE',
}
